module.exports = __webpack_public_path__ + "f530e6426.jpg";